import { useContext } from "react";
import { SubscriptionContext, SubscriptionDispatchContext } from "../../..";
import { buildApplicationFormBody, getValidationMethod } from "../../../utils";
import useMutation from "~/hooks/useMutation";

export function useApplicationFormHandlers() {
  const { school = {}, form = {} } = useContext(SubscriptionContext);
  const { values = {} } = form;
  const dispatch = useContext(SubscriptionDispatchContext);

  const {
    isLoading,
    error,
    mutationFn: createSubscriptionApplication,
  } = useMutation(`/api/subscription/application`, {
    method: "POST",
    headers: { "Content-type": "application/json" },
    body: JSON.stringify(buildApplicationFormBody(school.sid, values)),
  });

  const handleInputChange = (e) => {
    const { name: property, value } = e.target;
    dispatch({
      type: "update_form_value",
      payload: { property, value },
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validForm = Object.keys(values).every((property) => {
      const validationMethod = getValidationMethod(property);
      return validationMethod(values);
    });

    if (!validForm) {
      dispatch({ type: "do_form_validation" });
      return;
    }

    dispatch({ type: "show_form_confirm" });
  };

  const handleConfirm = async () => {
    const { data, isSuccess } = await createSubscriptionApplication();
    if (isSuccess) {
      dispatch({ type: "set_pending_application", payload: data });
      document?.getElementById("tabs-subscription")?.scrollTo(0, 0);
    }
  };

  return {
    handleConfirm,
    handleInputChange,
    handleSubmit,
    submissionLoading: isLoading,
    submissionError: error,
  };
}
